import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_COUNTRY_BANNER = createFcmDetails('country_banner', {
	// owner: '',
	context: 'Homepage and petition page',
	description: `Banner displayed on the homepage and/or the petition page (based on the "context" value).

		"banner_petition_id" can be used to only display the banner when not on that petition page, and when the user has not signed that petition.
`,
	template: {
		content: 'Desktop text',
		mobileContent: 'Mobile text',
		context: ['petition', 'home'],
		banner_petition_id: '42',
	},
	import: false,
});
